const SUPERADMIN_STATS_PROD_HOSTS = new Set(["asasiasa.com", "www.asasiasa.com"]);

export const shouldShowSuperAdminStats = () => {
  if (typeof window === "undefined") {
    return false;
  }

  return SUPERADMIN_STATS_PROD_HOSTS.has(window.location.hostname);
};
